module.exports = __webpack_public_path__ + "img/home-educacao.490aa3f7.svg";